import React, { memo, useCallback, useEffect } from 'react';

import { Form, Formik } from 'formik';
import type { FormikProps } from 'formik';
import { initialFilterValues } from 'v2/interfaces/rating';
import type { IFilter } from 'v2/interfaces/rating';
import producerRatingService from 'v2/services/rating/producer';

import Fields from './Fields';

const Filters = memo(() => {
  useEffect(() => {
    producerRatingService.setFilter(initialFilterValues);
  }, []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    for (const value in values) {
      const v = value as keyof IFilter;

      if (!values[v] || values[v] === null || values[v] === '') {
        delete values[v];
      }
    }

    producerRatingService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <div className='w-full rounded-sm bg-white p-5 shadow-sm [&_.--align-end]:flex [&_.--align-end]:items-end [&_.--align-end]:justify-end [&_.--align-end]:pl-3 [&_.--align-end_button:last-child]:ml-6 [&_.--align-end_button:last-child]:w-full [&_form]:w-full'>
      <Formik initialValues={initialFilterValues} onSubmit={onSubmit}>
        {() => (
          <Form>
            <Fields />
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default Filters;
